import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { RequesterField, RequesterFieldExtensionSchema } from './Requester';

export const AWSWorkloadRequesterFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AWSWorkload_Requester',
    component: RequesterField,
    schema: RequesterFieldExtensionSchema,
  }),
);
